import { common } from '../common';
import { urls } from '../urls';

export const viewerService = {

    getPageThumb: async function (payload) {

      let url = new URL(urls.viewer.urlGetPageThumb, urls.baseUrl);
      let params = new URLSearchParams(payload);
      url.search = params;
      const response = await fetch(url, {
        method: "GET"
      });
      if (!response.ok) {
        return common.handlerLiquidHttpErrorResponse(response);
      }
      return response.blob();

    },

    getPageAsPDFFile: async function (pageid, token) {

      let data = {
        pageid: pageid,
        token: token
      };
      let url = new URL(urls.viewer.urlGetPageAsPDFFile, urls.baseUrl);
      let params = new URLSearchParams(data);
      url.search = params;
      const response = await fetch(url, {
        method: "GET"
      });
      if (!response.ok) {
        return common.handlerLiquidHttpErrorResponse(response);
      }
      return response.blob();
    },

    getPageFile: async function (payload) {

      let url = new URL(urls.viewer.urlGetPageFile, urls.baseUrl);
      let params = new URLSearchParams(payload);
      url.search = params;
      const response = await fetch(url, {
        method: "GET"
      });
      if (!response.ok) {
        return common.handlerLiquidHttpErrorResponse(response);
      }
      return response.blob();

    },

    getViewSummary: async function (payload) {

      let url = new URL(urls.viewer.urlGetViewSummary, urls.baseUrl);
      let params = new URLSearchParams(payload);
      url.search = params;
      const response = await fetch(url, {
        method: "GET"
      });
      if (!response.ok) {
        return common.handlerLiquidHttpErrorResponse(response);
      }
      return response.json();

    },

    getViewPermissions: async function (payload) {

      let url = new URL(urls.viewer.urlGetViewPermissions, urls.baseUrl);
      let params = new URLSearchParams(payload);
      url.search = params;
      const response = await fetch(url, {
        method: "GET"
      });
      if (!response.ok) {
        return common.handlerLiquidHttpErrorResponse(response);
      }
      return response.json();

    },

    postConvertPageAsPDFFile: async function (formData) {

      let url = new URL(urls.viewer.urlConvertPageAsPDFFile, urls.baseUrl);
      const response = await fetch(url, {
        method: "POST",
        body: formData
      });
      if (!response.ok) {
        return common.handlerLiquidHttpErrorResponse(response);
      }
      return response.blob();

    },

    getPageFileUrl: function (payload) {
      return `${urls.viewer.urlGetPageFile}?id=${payload.id}&ordem=${payload.ordem}&download=false&marcacoes=true&token=${encodeURIComponent(payload.token)}`;
    }

};